import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag, Radio } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
class Filters extends React.Component {


    handleChange = (option) => {

        this.props.onChange("idCliente", option.key, "cliente", option.label[2].split('-')[0]);
        //this.props.onChange("cliente", option.label[2])
    }


    handleChangeEstado = (option) => {

        this.props.onChange("IdEstado", option.key, "estado", option.label[2].split('-')[0]);
        //this.props.onChange("cliente", option.label[2])
    }

    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.cliente}
                            onChange={(e) => this.props.onChange("cliente", e.target.value)}
                            placeholder="Filtrar por cliente, Ruc"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idTipoComprobante ?
                                    { key: this.props.filter.idTipoComprobante } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Tipo Comprobante" />}
                            onChange={(option) => this.props.onChange("idTipoComprobante", option.key, option, 'Comprobante')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.listaTipoComprobante.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idMetodoPago ?
                                    { key: this.props.filter.idMetodoPago } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Metodo Pago" />}
                            onChange={(option) => this.props.onChange("idMetodoPago", option.key, option, 'metodoPago')}
                            optionFilterProp="children"
                        >
                            {this.props.metodoPagos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id} >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idCuenta ?
                                    { key: this.props.filter.idCuenta } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por cuenta" />}
                            onChange={(option) => this.props.onChange("idCuenta", option.key, option, 'cuenta')}
                            optionFilterProp="children"
                        >
                            {this.props.cuentas.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id} >{item.cuentaBancario}</Select.Option>

                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value, null, null)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Serie"
                            autoComplete="off"
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value, null, null)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Documento"
                            autoComplete="off"
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value, null, null)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value, null, null)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;